import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M1.3 4a.7.7 0 0 1 .7-.7h7.879a.7.7 0 0 1 .483.193l1.817 1.732H22a.7.7 0 0 1 .7.7V20a.7.7 0 0 1-.7.7H2a.7.7 0 0 1-.7-.7V4Zm1.4.7v14.6h18.6V6.625h-9.401a.7.7 0 0 1-.483-.193L9.6 4.7H2.7Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M10.645 9.99a1.355 1.355 0 0 0-1.901 0c-.521.515-.521 1.348 0 1.864a1.355 1.355 0 0 0 1.9 0c.521-.515.521-1.35 0-1.865Zm-2.746-.854a2.555 2.555 0 0 1 3.59 0 2.508 2.508 0 0 1 0 3.57 2.555 2.555 0 0 1-3.59 0 2.508 2.508 0 0 1 0-3.57Zm7.67 1.047a.798.798 0 1 0-1.128 1.128.798.798 0 0 0 1.128-1.128Zm-1.977-.849a1.998 1.998 0 1 1 2.825 2.825 1.998 1.998 0 0 1-2.825-2.825Zm2.81 5.073h-2.096a.6.6 0 1 1 0-1.2h2.097c1.103 0 1.997.894 1.997 1.997a.6.6 0 1 1-1.2 0 .798.798 0 0 0-.797-.797Zm-8.649.713a.945.945 0 0 0-.953.938v.442a.6.6 0 1 1-1.2 0v-.442c0-1.186.97-2.137 2.153-2.137h3.882c1.184 0 2.153.95 2.153 2.137v.442a.6.6 0 1 1-1.2 0v-.442a.945.945 0 0 0-.953-.938H7.753Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
